<template>
  <div>
    <div
      v-for="(htmlContent, index) in copyBlock"
      :key="index"
      :class="getClassAttributes(htmlContent?.attributes)"
    >
      <h2
        class="copy-block-header h3"
        v-html="sanitize(htmlContent?.text, cleanStyle)"
      />

      <div
        :class="[
          'copy-block',
          `${!copyBlocksExpanded[index]?.isExpanded ? 'more' : 'less'}`,
        ]"
        v-html="sanitize(htmlContent?.description, cleanStyle)"
      />
      <button
        class="show-link"
        @click.prevent="onToggleShow(index)"
      >
        <span class="link-sm">{{
          showToggleText(copyBlocksExpanded[index]?.isExpanded)
        }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { sanitize } from '@vue-util/sanitize';
import { getClassAttributes } from '../../helpers/getAttributes';
import cleanStyles from '../../helpers/getCleanStyles';

const props = defineProps({
  copyBlock: {
    type: Array,
    default: () => [],
  },
});

const cleanStyle = {
  ...cleanStyles,
  onTag: (tag, html, options) => { // eslint-disable-line consistent-return
    if (tag === 'h2' && !options.isClosing) {
      return '<h2 class="h3">';
    }
  },
};

const copyBlocksExpanded = ref([]);

copyBlocksExpanded.value = props?.copyBlock?.map((copyBlock) => (
  { isExpanded: copyBlock.expand || false }
));

const onToggleShow = (index) => {
  copyBlocksExpanded.value[index].isExpanded = !copyBlocksExpanded.value[index].isExpanded;
};
const showToggleText = (isExpanded) => `Show ${!isExpanded ? 'More' : 'Less'}`;
</script>

<style lang="scss" scoped>
@import "~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss";
.copy-block {
  &.more:deep() {
    p:first-of-type {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    p:not(:first-of-type) {
      display: none;
    }
  }
  &.less {
    overflow: visible;
  }
  :deep() {
    ul, ol{
      list-style-type:none;
    }
    p {
      @include margin-direction("bottom", map-get($spacer, "xs"));
    }
  }
}
.copy-block-header {
  @include margin-direction("bottom", map-get($spacer, "m"));
}
#top_0{
  .copy-block-header{
    display:none;
  }
}
</style>
<style lang="scss" brand="mcom" scoped>
@import "./../../scss/globalAttributes.mcom.scss";
</style>
<style lang="scss" brand="bcom" scoped>
@import "./../../scss/globalAttributes.bcom.scss";
</style>
